/* Mini Shop Platform — Khmer / English translations */
import React, { createContext, useContext, useEffect, useState } from 'react';

const kh = {
  // navigation
  home: 'ទំព័រដើម',
  products: 'ផលិតផល',
  about: 'អំពីយើង',
  searchPlaceholder: 'ស្វែងរកផលិតផល...',
  cart: 'កន្ត្រក',
  addToCart: 'បន្ថែមទៅកន្ត្រក',
  yourCart: 'កន្ត្រករបស់អ្នក',
  cartEmpty: 'កន្ត្រករបស់អ្នកទទេ',
  subtotal: 'សរុបរង',
  proceedCheckout: 'បន្តទៅការទូទាត់',
  continueShopping: 'បន្តទិញទំនិញ',

  // products
  shopNow: 'ទិញឥឡូវនេះ',
  featuredProducts: 'ផលិតផលពិសេស',
  viewAll: 'មើលទាំងអស់',
  categories: 'ប្រភេទ',
  all: 'ទាំងអស់',
  chatbot: 'ជជែកជាមួយហាង',
  chatbotPlaceholder: 'សួរអំពីទំនិញ តម្លៃ ការដឹកជញ្ជូន...',
  chatbotSend: 'ផ្ញើ',
  chatbotThinking: 'កំពុងវាយ...',
  chatbotError: 'មានបញ្ហា សូមព្យាយាមម្តងទៀត។',
  chatbotSuggest: 'សំណួរដែលអ្នកអាចសួរ',
  articles: 'អត្ថបទ',
  videos: 'វីដេអូ',
  noArticles: 'មិនទាន់មានអត្ថបទទេ',
  noVideos: 'មិនទាន់មានវីដេអូទេ',
  promotion: 'ប្រូម៉ូសិន',
  promotions: 'ប្រូម៉ូសិន',
  promotionOffer: 'ការផ្តល់ជូនពិសេស',
  close: 'បិទ',
  viewImage: 'មើលរូបភាពធំ',
  prev: 'មុន',
  next: 'បន្ទាប់',
  loading: 'កំពុងផ្ទុក...',
  loadingShop: 'កំពុងផ្ទុកហាង...',
  noProducts: 'រកមិនឃើញផលិតផល',
  noFeatured: 'មិនទាន់មានផលិតផលពិសេសនៅឡើយទេ',
  productDetails: 'ព័ត៌មានលម្អិតផលិតផល',
  description: 'ការពិពណ៌នា',
  relatedProducts: 'ផលិតផលពាក់ព័ន្ធ',
  back: 'ត្រឡប់ក្រោយ',
  inStock: 'មានក្នុងស្តុក',
  outOfStock: 'អស់ស្តុក',
  qty: 'ចំនួន',
  sale: 'បញ្ចុះតម្លៃ',

  // checkout
  checkout: 'ការទូទាត់',
  customerInfo: 'ព័ត៌មានអតិថិជន',
  name: 'ឈ្មោះ',
  emailOpt: 'អ៊ីមែល (ស្រេចចិត្ត)',
  phone: 'លេខទូរស័ព្ទ',
  telegramOpt: 'តេឡេក្រាម (ស្រេចចិត្ត)',
  address: 'អាសយដ្ឋាន',
  city: 'ទីក្រុង',
  country: 'ប្រទេស',
  noteOpt: 'កំណត់ចំណាំ (ស្រេចចិត្ត)',
  placingOrder: 'កំពុងដាក់ការបញ្ជាទិញ...',
  pay: 'បង់ប្រាក់',
  orderSummary: 'សង្ខេបការបញ្ជាទិញ',
  shipping: 'ការដឹកជញ្ជូន',
  free: 'ឥតគិតថ្លៃ',
  total: 'សរុប',
  securedBy: 'ការពារដោយ ABA Pay (KHQR)',
  fillRequired: 'សូមបំពេញគ្រប់វាលដែលតម្រូវ',

  // payment screen
  orderPlacedTitle: 'ការបញ្ជាទិញបានដាក់ — បង់ប្រាក់តាម ABA Pay',
  orderId: 'លេខបញ្ជាទិញ',
  amountToPay: 'ចំនួនទឹកប្រាក់ត្រូវបង់',
  merchant: 'ឈ្មួញ',
  dateTime: 'កាលបរិច្ឆេទ / ពេលវេលា',
  scanWithABA: 'ស្កេនជាមួយកម្មវិធី ABA Mobile',
  securePayment: 'ការទូទាត់សុវត្ថិភាព',
  paywayPoweredBy: 'ដំណើរការដោយ ABA Payway · ការទូទាត់សុវត្ថិភាព',
  scanQr: 'ស្កេនកូដ KHQR ជាមួយកម្មវិធី ABA Mobile ឬបើកទំព័រទូទាត់ដែលមានសុវត្ថិភាព។',
  payWithABA: 'បង់ប្រាក់តាម ABA Pay',
  alreadyPaid: 'ខ្ញុំបានបង់ប្រាក់រួចហើយ — ពិនិត្យ',
  waitingPayment: 'កំពុងរង់ចាំការបញ្ជាក់ការទូទាត់...',
  autoCheck: 'ការទូទាត់ត្រូវបានពិនិត្យដោយស្វ័យប្រវត្តិរៀងរាល់ ៣ វិនាទី។',
  transId: 'លេខប្រតិបត្តិការ',
  paymentConfirmed: 'ការទូទាត់បានបញ្ជាក់! កំពុងបញ្ជូនបន្ត...',
  paymentUnavailable: 'ការទូទាត់តាមអ៊ីនធឺណិតមិនអាចប្រើបានទេ',
  paymentUnavailableDesc: 'ហាងនេះមិនទាន់កំណត់រចនាសម្ព័ន្ធ ABA Pay នៅឡើយទេ ដូច្នេះការទូទាត់តាមអ៊ីនធឺណិតត្រូវបានបិទ។ សូមទាក់ទងហាងដើម្បីបញ្ចប់ការបញ្ជាទិញរបស់អ្នក។',
  backToProducts: 'ត្រឡប់ទៅផលិតផល',
  paymentPending: 'ការទូទាត់នៅមិនទាន់បញ្ចប់។ សូមបំពេញការទូទាត់ក្នុងកម្មវិធី ABA Mobile។',

  // order success
  paymentSuccess: 'ការទូទាត់ជោគជ័យ!',
  paymentSuccessMsg: 'សូមអរគុណសម្រាប់ការទិញរបស់អ្នក។ បង្កាន់ដៃត្រូវបានបង្កើតសម្រាប់ការបញ្ជាទិញរបស់អ្នក។',
  orderPlacedMsg: 'ការបញ្ជាទិញរបស់អ្នកត្រូវបានដាក់។ អ្នកអាចពិនិត្យស្ថានភាពការទូទាត់ខាងក្រោម។',
  downloadReceipt: 'ទាញយកបង្កាន់ដៃ PDF',
  downloadInvoice: 'ទាញយកវិក្កយបត្រ PDF',
  orderNotFound: 'រកមិនឃើញការបញ្ជាទិញ',
  orderNotFoundDesc: 'រកមិនឃើញការបញ្ជាទិញនេះ។ សូមពិនិត្យលេខការបញ្ជាទិញរបស់អ្នក។',
  orderNumber: 'លេខការបញ្ជាទិញ',
  date: 'កាលបរិច្ឆេទ',
  paymentStatus: 'ស្ថានភាពការទូទាត់',
  orderStatus: 'ស្ថានភាពការបញ្ជាទិញ',
  itemsLabel: 'ទំនិញ',
  customerLabel: 'អតិថិជន',

  // footer / about
  shopUnavailable: 'ហាងមិនអាចប្រើបាន',
  shopNotFoundMsg: 'រកមិនឃើញហាង ឬហាងត្រូវបានផ្អាក',
  backHome: 'ត្រឡប់ទៅទំព័រដើម',
  aboutUs: 'អំពីយើង',
  followUs: 'តាមដានយើង',
  contact: 'ទំនាក់ទំនង',
  quickLinks: 'តំណរហ័ស',
  poweredBy: 'ដំណើរការដោយ Mini Shop Platform',
  weAccept: 'យើងទទួលយកការទូទាត់',
  fastDelivery: 'ការដឹកជញ្ជូនលឿន',
  fastDeliveryDesc: 'ការដឹកជញ្ជូនលឿន និងគួរឱ្យទុកចិត្តទូទាំងប្រទេស។',
  abaAccepted: 'ទទួលយក ABA Pay',
  abaAcceptedDesc: 'បង់ប្រាក់ងាយស្រួលជាមួយ ABA Mobile ដោយស្កេនកូដ KHQR។',
  support: 'ការគាំទ្រអតិថិជន',
  supportDesc: 'ទាក់ទងមកយើងបានគ្រប់ពេលតាម Telegram។',
  welcome: 'ស្វាគមន៍!',
  notFound404: 'រកមិនឃើញទំព័រ។ សូមសាកល្បងចូលទស្សនាហាងដូចជា /demo។',
  goToDemo: 'ទៅកាន់ហាងសាកល្បង',
  somethingWrong: 'មានបញ្ហាអ្វីមួយបានកើតឡើង',
  reload: 'ផ្ទុកទំព័រឡើងវិញ',

  // my orders (customer history)
  myOrders: 'ការបញ្ជាទិញរបស់ខ្ញុំ',
  myOrdersLoginDesc: 'បញ្ចូលលេខទូរស័ព្ទ ឬឈ្មោះតេឡេក្រាមរបស់អ្នក ដើម្បីមើលប្រវត្តិការបញ្ជាទិញរបស់អ្នក។',
  loginWithTelegram: 'ចូលជាមួយ Telegram',
  viewMyOrders: 'មើលការបញ្ជាទិញរបស់ខ្ញុំ',
  noOrdersFound: 'មិនទាន់មានការបញ្ជាទិញសម្រាប់ព័ត៌មាននេះទេ។',
  viewDetail: 'មើលលម្អិត',
  hideDetail: 'បិទលម្អិត',
  orderDetail: 'ព័ត៌មានលម្អិតកុម្ម៉ង់',
  shippingAddress: 'អាសយដ្ឋានដឹកជញ្ជូន',
  paymentMethod: 'វិធីបង់ប្រាក់',
  transactionId: 'លេខប្រតិបត្តិការ',
  email: 'អ៊ីមែល',
  discount: 'បញ្ចុះតម្លៃ',
  ordersFound: 'ការបញ្ជាទិញ',
  orderHistory: 'ប្រវត្តិការបញ្ជាទិញ',
  logOut: 'ចាកចេញ',
  dashboard: 'ផ្ទាំងគ្រប់គ្រង',
  viewMyShop: 'មើលហាងរបស់ខ្ញុំ',
  youOwnThisShop: 'អ្នកគឺជាម្ចាស់ហាងនេះ',
  joinTelegram: 'ចូលរួមឆានែល Telegram',
  contactThisOwner: 'ទាក់ទងម្ចាស់ហាងនេះ',
  searchMyOrders: 'ស្វែងរកការបញ្ជាទិញរបស់ខ្ញុំ',

  // telegram login
  tgLoginRequired: 'សូមចូលតាម Telegram ដើម្បីទិញទំនិញ',
  tgLoginRequiredDesc: 'អ្នកត្រូវតែចូលជាមួយគណនី Telegram របស់អ្នក មុនពេលអាចដាក់ការបញ្ជាទិញ។',
  tgLoginSuccess: 'ចូលបានជោគជ័យតាម Telegram!',
  tgLoggedIn: 'បានចូលតាម Telegram',
  tgLoggingIn: 'កំពុងចូល...',
  tgFallbackTitle: 'ឬចូលជាមួយលេខកូដ',
  tgFallbackHow: 'គ្មានប៊ូតុង? បើក',
  tgFallbackStart: 'ក្នុង Telegram ចុច Start រួចបញ្ចូលលេខសម្គាល់ Telegram របស់អ្នកខាងក្រោម។',
  tgYourId: 'លេខសម្គាល់ Telegram របស់អ្នក',
  tgSendCode: 'ផ្ញើកូដ',
  tgEnterCode: 'បញ្ចូលលេខកូដ 6 ខ្ទង់ដែលផ្ញើទៅ Telegram របស់អ្នក',
  tgVerify: 'ផ្ទៀងផ្ទាត់',
  tgBack: 'ត្រឡប់',
  tgInvalidId: 'សូមបញ្ចូលលេខសម្គាល់ Telegram ត្រឹមត្រូវ (មានតែលេខ)',
  tgInvalidCode: 'លេខកូដត្រូវតែមាន 6 ខ្ទង់',
  tgCodeSent: 'លេខកូដត្រូវបានផ្ញើទៅ Telegram របស់អ្នក!',

  // customer account
  signIn: 'ចូលគណនី',
  signUp: 'ចុះឈ្មោះ',
  createAccount: 'បង្កើតគណនី',
  emailOrPhone: 'អ៊ីមែល ឬ លេខទូរស័ព្ទ',
  loginIdentifier: 'ឈ្មោះអ្នកប្រើ ឬ Gmail',
  username: 'ឈ្មោះអ្នកប្រើ',
  myProfile: 'គណនីរបស់ខ្ញុំ',
  viewProfile: 'មើលគណនី',
  fullName: 'ឈ្មោះពេញ',
  memberSince: 'សមាជិកតាំងពី',
  editProfile: 'កែប្រែគណនី',
  save: 'រក្សាទុក',
  cancel: 'បោះបង់',
  profileUpdated: 'បានធ្វើបច្ចុប្បន្នភាពគណនីរបស់អ្នក!',
  changePassword: 'ប្តូរពាក្យសម្ងាត់',
  currentPassword: 'ពាក្យសម្ងាត់បច្ចុប្បន្ន',
  newPassword: 'ពាក្យសម្ងាត់ថ្មី',
  passwordUpdated: 'បានប្តូរពាក្យសម្ងាត់ដោយជោគជ័យ!',
  updatePassword: 'បញ្ជាក់ការប្តូរពាក្យសម្ងាត់',
  qrCode: 'ស្កេន QR',
  downloadQr: 'ទាញយក QR',
  scanToVisit: 'ស្កេនដើម្បីចូលទស្សនាហាង',
  telegram: 'តេឡេក្រាម',
  password: 'ពាក្យសម្ងាត់',
  confirmPassword: 'បញ្ជាក់ពាក្យសម្ងាត់',
  passwordMismatch: 'ពាក្យសម្ងាត់ទាំងពីរមិនត្រូវគ្នា! សូមពិនិត្យម្តងទៀត',
  showPassword: 'បង្ហាញពាក្យសម្ងាត់',
  hidePassword: 'លាក់ពាក្យសម្ងាត់',
  firstName: 'នាមត្រកូល',
  lastName: 'នាមខ្លួន',
  gender: 'ភេទ',
  male: 'ប្រុស',
  female: 'ស្រី',
  other: 'ផ្សេងទៀត',
  gmail: 'អ៊ីមែល (Gmail)',
  telegramUsername: 'ឈ្មោះអ្នកប្រើ Telegram',
  telegramPhone: 'លេខទូរស័ព្ទ Telegram',
  welcomeBack: 'សូមស្វាគមន៍',
  signInRequired: 'សូមចូលគណនីរបស់អ្នក ដើម្បីទិញទំនិញ',
  signInRequiredDesc: 'បង្កើតគណនី ឬចូលគណនី ដើម្បីដាក់ការបញ្ជាទិញ និងមើលប្រវត្តិការបញ្ជាទិញរបស់អ្នក។',

  // landing page
  heroTitle: 'ស្វាគមន៍មកកាន់ Mini Shop',
  heroSubtitle: 'វេទិកាអ៊ីកូមមឺសពហុហាង ដែលមានការទូទាត់ ABA Pay (KHQR) បង្កាន់ដៃ PDF និងការជូនដំណឹងតាម Telegram។',
  featuresTitle: 'លក្ខណៈពិសេសរបស់វេទិកា',
  featuresLabel: 'លក្ខណៈពិសេស',
  featureMultiShop: 'វេទិកាពហុហាង',
  featureMultiShopDesc: 'ហាងនីមួយៗមាន username ផ្ទាល់ខ្លួន និងទំព័រដាច់ដោយឡែក (/:username)។',
  featureCustom: 'ការកំណត់ហាងពេញលេញ',
  featureCustomDesc: 'ឡូហ្គោ ផ្ទាំងបដា ពណ៌ និងប្រភេទពុម្ពអក្សរផ្ទាល់ខ្លួន។',
  featureAbapay: 'ការរួមបញ្ចូល ABA Pay',
  featureAbapayDesc: 'ការទូទាត់ KHQR ដោយសុវត្ថិភាពសម្រាប់ហាងនីមួយៗ។',
  featureReceipts: 'បង្កាន់ដៃ PDF',
  featureReceiptsDesc: 'បង្កាន់ដៃដែលអាចបោះពុម្ពបាន ជាមួយឡូហ្គោហាង និងព័ត៌មានការបញ្ជាទិញ។',
  featureBackup: 'ការបម្រុងទុកទិន្នន័យ',
  featureBackupDesc: 'បម្រុងទុក និងស្ដារទិន្នន័យហាងទាំងអស់ (JSON/ZIP)។',
  featureTelegram: 'ការជូនដំណឹងតាម Telegram',
  featureTelegramDesc: 'ទទួលការជូនដំណឹងការទូទាត់ភ្លាមៗទៅកាន់ក្រុមរបស់អ្នក។',
  howItWorks: 'របៀបចាប់ផ្តើមហាងរបស់អ្នក',
  howItWorksDesc: 'គណនីត្រូវបានបង្កើតដោយអ្នកគ្រប់គ្រងតែប៉ុណ្ណោះ (មិនអាចចុះឈ្មោះដោយខ្លួនឯងបានទេ)។ ទាក់ទងយើងតាម Telegram:',
  browseDemo: 'ចូលមើលហាងសាកល្បង',
  viewAdmin: 'ផ្ទាំងគ្រប់គ្រង',
  viewDashboard: 'ផ្ទាំងគ្រប់គ្រងហាង',
  poweredText: 'ដំណើរការដោយ Mini Shop Platform',
  pricingTitle: 'កញ្ចប់តម្លៃ',
  pricingSubtitle: 'ជ្រើសរើសកញ្ចប់ដែលសមនឹងហាងរបស់អ្នក — អាចបន្ថែមលុយដើម្បីដំឡើងកញ្ចប់នៅពេលណាក៏បាន។',
  planStarter: 'កញ្ចប់ចាប់ផ្តើម',
  planStarterPrice: '$9.99',
  planStarterPeriod: '/1 ខែ',
  createShopHero: 'បង្កើតហាងអនឡាញរបស់អ្នកក្នុងពេលប៉ុន្មាននាទី — ចាប់ផ្តើមត្រឹម $9.99/ខែ',
  planStarterFeat: ['20 ផលិតផល', '10 ប្រភេទ', 'ABA PayWay (KHQR)'],
  planGrowth: 'កញ្ចប់រីកចម្រើន',
  planGrowthPrice: '$55.99',
  planGrowthPeriod: '/6 ខែ',
  planGrowthFeat: ['50 ផលិតផល', '20 ប្រភេទ', 'ABA PayWay (KHQR)'],
  planPremium: 'កញ្ចប់ពេញ',
  planPremiumPrice: '$99.99',
  planPremiumPeriod: '/1 ឆ្នាំ',
  planPremiumFeat: ['200 ផលិតផល', '30 ប្រភេទ', 'ABA PayWay (KHQR)'],
  everythingIncluded: 'រួមបញ្ចូលទាំងអស់',
  planIncludes: ['ប្រព័ន្ធ POS (លក់នៅហាង)', 'ផលិតផល', 'ប្រភេទ', 'ស្តុក',
                 'ការបញ្ជាទិញ', 'អតិថិជន', 'របាយការណ៍', 'បង្កាន់ដៃ',
                 'ការកំណត់ហាង', 'ការទូទាត់ ABA Pay', 'Telegram Bot',
                 'បម្រុងទុក និងស្តារឡើងវិញ'],
  popularTag: 'ពេញនិយមបំផុត',
  upgradeNote: 'ចង់បានផលិតផល ឬប្រភេទបន្ថែមទៀត? បន្ថែមលុយដើម្បីដំឡើងកញ្ចប់ ($99.99/ឆ្នាំ)។',
  openShop: 'បើកហាងរបស់អ្នក',
  openShopDesc: 'ទាក់ទង @thymuoyhak ដើម្បីបើកហាងថ្មីឥឡូវនេះ',
  tryDemo: 'សាកល្បងហាងសាកល្បង',
  liveDemoTitle: 'មើលហាងសាកល្បងផ្ទាល់',
  liveDemoDesc: 'នេះគឺជាហាងសាកល្បងដែលដំណើរការពិតប្រាកដនៅលើ Mini Shop — រុករក និងសាកល្បងការបញ្ជាទិញ។',

  // homepage (brand landing)
  heroBadge: 'វេទិកាអ៊ីកូមមឺសពហុហាងនៅកម្ពុជា 🇰🇭',
  heroTitleMain: 'មានហាងអនឡាញផ្ទាល់ខ្លួន',
  heroTitleMain2: 'ក្នុងរយៈពេលប៉ុន្មាននាទី។',
  heroDesc: 'Mini Shop កម្ពុជាអនុញ្ញាតឱ្យអ្នកបើកហាងអនឡាញដែលមានជំនាញវិជ្ជាជីវៈជាមួយតំណផ្ទាល់ខ្លួន ការទូទាត់ ABA Pay (KHQR) បង្កាន់ដៃ PDF ប្រព័ន្ធ POS និងការជូនដំណឹងតាម Telegram — មិនចាំបាច់សរសេរកូដ មិនគិតថ្លៃចាប់ផ្តើម និងមិនកាត់កំរៃលើការលក់របស់អ្នក។',
  browseDemo2: 'ចូលមើលហាងសាកល្បង',
  startMyShop: 'បង្កើតហាងរបស់ខ្ញុំ',
  needHelp: 'ត្រូវការជំនួយ?',
  statShops: 'ហាងនៅលើវេទិកា',
  statProducts: 'ផលិតផលនៅលើវេទិកា',
  statCustomers: 'អតិថិជនរីករាយ',
  statSupport: 'ជំនួយ និងតាមដាន',
  aboutLabel: 'អំពី Mini Shop កម្ពុជា',
  aboutTitle: 'អ្វីគ្រប់យ៉ាងដែលអ្នកត្រូវការដើម្បីលក់តាមអនឡាញនៅកម្ពុជា',
  aboutP1: 'Mini Shop កម្ពុជាគឺជាវេទិកាអ៊ីកូមមឺសពហុហាងដែលបង្កើតឡើងសម្រាប់អាជីវកម្មក្នុងស្រុក។ ហាងនីមួយៗទទួលបាន storefront ផ្ទាល់ខ្លួនជាមួយតំណផ្ទាល់ខ្លួន ផ្ទាំងគ្រប់គ្រងពេញលេញ (ផលិតផល ប្រភេទ ស្តុក ការបញ្ជាទិញ អតិថិជន របាយការណ៍) ប្រព័ន្ធ POS ដែលមានជំនាញវិជ្ជាជីវៈ និងការទូទាត់ ABA Pay (KHQR) ពិតប្រាកដ ដើម្បីឱ្យអតិថិជនអាចបង់ប្រាក់ភ្លាមៗតាមទូរស័ព្ទ។',
  aboutP2: 'ការទូទាត់ត្រូវបានបញ្ជាក់ដោយស្វ័យប្រវត្តិ បង្កាន់ដៃ PDF ពីរភាសា (ខ្មែរ + អង់គ្លេស ជាមួយឡូហ្គោ និងពណ៌ម៉ាករបស់អ្នក) ត្រូវបានបង្កើតសម្រាប់រាល់ការបញ្ជាទិញ ហើយអ្នកទទួលបានការជូនដំណឹង Telegram ភ្លាមៗ — ការបញ្ជាទិញថ្មី ការទូទាត់ និងការជូនដំណឹងស្តុកទាបទៅកាន់ទូរស័ព្ទរបស់អ្នក។',
  aboutPoint1: 'ឥតគិតថ្លៃចាប់ផ្តើម — បង់តែពេលជ្រើសរើសកញ្ចប់',
  aboutPoint2: 'មិនកាត់កំរៃលើការលក់របស់អ្នក',
  aboutPoint3: 'ភាសាខ្មែរ និងអង់គ្លេស សម្រាប់ហាង និងអ្នកគ្រប់គ្រង',
  aboutPoint4: 'ងាយស្រួលប្រើលើទូរស័ព្ទសម្រាប់អតិថិជនគ្រប់រូប',
  talkToUs: 'ទាក់ទងមកយើង',
  value500: '500+ ហាង',
  value500Desc: 'ទីផ្សារដែលកំពុងរីកចម្រើននៃអាជីវកម្មក្នុងស្រុកទូទាំងប្រទេសកម្ពុជា។',
  valueAba: 'ABA Pay (KHQR)',
  valueAbaDesc: 'កូដ QR ខ្មែរពិតប្រាកដ — ស្កេន និងបង់ប្រាក់ក្នុងរយៈពេលប៉ុន្មានវិនាទី។',
  valueInv: 'បង្កាន់ដៃ PDF',
  valueInvDesc: 'បង្កាន់ដៃពីរភាសាដែលមានជំនាញវិជ្ជាជីវៈ ជាមួយម៉ាករបស់អ្នក។',
  valueDel: 'គ្រប់គ្រងការដឹកជញ្ជូន',
  valueDelDesc: 'អាសយដ្ឋានអតិថិជន និងស្ថានភាពការបញ្ជាទិញពីចុងដល់ចុង។',
  stepsTitle: 'ចាប់ផ្តើមលក់តាមអនឡាញក្នុង ៣ ជំហាន',
  step1Title: 'បង្កើតហាងរបស់អ្នក',
  step1Desc: 'ជ្រើសរើសកញ្ចប់ ចុះឈ្មោះហាងក្នុងរយៈពេល ២ នាទី ហើយបង់ប្រាក់ដោយសុវត្ថិភាពជាមួយ ABA Pay (KHQR)។',
  step2Title: 'បន្ថែមផលិតផល និងកែសម្ផស្ស',
  step2Desc: 'បង្ហោះផលិតផល ប្រភេទ ឡូហ្គោ បដា និងពណ៌ម៉ាករបស់អ្នក។ មិនចាំបាច់សរសេរកូដទេ។',
  step3Title: 'ចាប់ផ្តើមលក់',
  step3Desc: 'ទទួលតំណ storefront របស់អ្នក ទទួលការបញ្ជាទិញ និងការទូទាត់ ABA ហើយអភិវឌ្ឍអាជីវកម្មរបស់អ្នក។',
  pricingLabel: 'តម្លៃកញ្ចប់',
  testiLabel: 'ម្ចាស់ហាងពេញចិត្ត',
  testiTitle: 'ជឿជាក់ដោយហាងរាប់រយ',
  testi1Name: 'សុខា ម.',
  testi1Shop: 'សម្លៀកបំពាក់ @sokhastyle',
  testi1Text: 'ខ្ញុំបើកហាងក្នុងមួយល្ងាច ហើយទទួលការទូទាត់ ABA លើកដំបូងនៅថ្ងៃបន្ទាប់។ បង្កាន់ដៃ PDF វិជ្ជាជីវៈណាស់!',
  testi2Name: 'ដារ៉ា ខ.',
  testi2Shop: 'គ្រឿងអេឡិចត្រូនិក @darashop',
  testi2Text: 'ប្រព័ន្ធ POS ធ្វើឱ្យការលក់ក្នុងហាងងាយស្រួលណាស់។ Telegram ទទួលរាល់ការបញ្ជាទិញភ្លាមៗ។',
  testi3Name: 'ច័ន្ទ រ.',
  testi3Shop: 'សម្រស់ @chanshop',
  testi3Text: 'ការគាំទ្រភាសាខ្មែរ និងអង់គ្លេស ព្រមទាំងពណ៌ម៉ាកហាងត្រូវនឹងម៉ាករបស់ខ្ញុំឥតខ្ចោះ។',
  ctaTitle: 'ត្រៀមខ្លួនដើម្បីអភិវឌ្ឍអាជីវកម្មរបស់អ្នកតាមអនឡាញ?',
  ctaDesc: 'ចូលរួមជាមួយហាង 500+ នៅលើ Mini Shop កម្ពុជាថ្ងៃនេះ — ចំណាយពេលតែប៉ុន្មាននាទីប៉ុណ្ណោះ។',
  startFree: 'ចាប់ផ្តើមហាងឥតគិតថ្លៃ',
  loadingMore: 'កំពុងផ្ទុកផលិតផលបន្ថែម...',
  showMore: 'បង្ហាញបន្ថែម',
  footerAbout: 'Mini Shop កម្ពុជា — វេទិកាអ៊ីកូមមឺសពហុហាងដែលអនុញ្ញាតឱ្យអ្នកគ្រប់គ្នាបើកហាងអនឡាញជាមួយ ABA Pay, POS និងបង្កាន់ដៃវិជ្ជាជីវៈ។',
  aboutMiniShop: 'អំពី Mini Shop',
  startYourShop: 'បង្កើតហាងរបស់អ្នក',
  contactFooter: 'ទំនាក់ទំនង',
  contactShops: '500+ ហាង · ភ្នំពេញ កម្ពុជា 🇰🇭',
  contactSupport: 'ជំនួយ: 24/7',
  copyright: '© {year} Mini Shop កម្ពុជា',

  // ---- Mini Shop Community (social platform) ----
  community: 'សហគមន៍ CodeKhmerLearning Community Beta',
  communityTagline: 'ចែករំលែក ចំណេះដឹង អត្ថបទ វីដេអូ និងជំនួញរបស់អ្នក',
  communityFreeForAll: 'អ្នកគ្រប់គ្នាអាចចែករំលែក · ឥតគិតថ្លៃ',
  moreFromAuthor: 'អត្ថបទផ្សេងទៀតពីអ្នកនិពន្ធ',
  joined: 'ចូលរួមតាំងពី',
  soundEffects: 'សំឡេងចុចប៊ូតុង',
  soundOn: 'បើកសំឡេង',
  soundOff: 'បិទសំឡេង',
  // Facebook-like post types + video / reels
  postTypeStatus: 'ស្ថានភាព',
  postTypePhoto: 'រូបភាព',
  postTypeVideo: 'វីដេអូ',
  postTypeStatusHint: 'សរសេរអ្វីមួយ ចែករំលែកជាមួយសហគមន៍ ✍️',
  postTypePhotoHint: 'បន្ថែមរូបភាព / GIF និងសរសេរការពិពណ៌នា 📷',
  postTypeVideoHint: 'ផ្ទុកវីដេអូ (អតិបរមា 10 MB បង្ហាប់ស្វ័យប្រវត្តិ) ឬដាក់លីងវីដេអូ 🎬',
  addVideo: 'បន្ថែមវីដេអូ',
  videoFile: 'វីដេអូ',
  videoHint: 'MP4 · អតិបរមា 10 MB · បង្ហាប់ស្វ័យប្រវត្តិ',
  videoUploaded: 'ផ្ទុកវីដេអូរួចរាល់',
  reelBadge: 'Reel',
  reelVerticalHint: 'វីដេអូឈរ (9:16) — នឹងបង្ហាញក្នុង Reels ផងដែរ 🎬',
  reelNav: 'Reel',
  reelsTitle: 'Reels',
  reelsHint: 'អូសឡើងលើដើម្បីមើលវីដេអូបន្ទាប់ · ចុចលើឈ្មោះដើម្បីមើលប្រវត្តិរូប',
  noReels: 'មិនមាន Reel ទេ',
  noReelsHint: 'ផុសវីដេអូឈរ (9:16) ឬបិទភ្ជាប់តំណវីដេអូ (YouTube Shorts · TikTok · Reel) ដើម្បីបង្ហាញនៅទីនេះ',
  noMoreReels: 'អស់ Reel ហើយ',
  mute: 'បិទសំឡេង',
  unmute: 'បើកសំឡេង',
  openPost: 'មើលអត្ថបទ',
  tapForSound: 'ចុចម្តងដើម្បីបើកសំឡេង (កម្មវិធីរុករកបានទប់សំឡេង)',
  randomFeed: 'ចៃដន្យ',
  noMorePosts: 'គ្មានអត្ថបទបន្ថែមទេ',
  orUpload: 'ឬផ្ទុកឡើង',
  videoStory: 'វីដេអូស្តូរី',
  uploadVideo: 'ផ្ទុកវីដេអូឡើង',
  uploadVideo10: 'ផ្ទុកវីដេអូឡើង (អតិបរមា 10 MB)',
  videoCompressHint: 'វីដេអូនឹងត្រូវបានបង្រួមដោយស្វ័យប្រវត្តិ (MP4 · 720p)',
  storyVideoMuted: 'ចុចដើម្បីបើកសំឡេង',
  sharePreviewHint: 'Facebook និង Telegram នឹងបង្ហាញរូបភាព + ចំណងជើងនេះ',
  sideMenu: 'ម៉ឺនុយចំហៀង',
  generalMenu: 'ទូទៅ',
  uploadImages: 'ផ្ទុករូបភាព (ច្រើន)',
  imagesReady: 'រូបភាពរួចរាល់ — ចុចផ្ញើ',
  pressSend: 'ចុចផ្ញើ',
  clearAll: 'លុបទាំងអស់',
  enableAlerts: 'បើកការជូនដំណឹងក្នុងកម្មវិធីរុករក',
  alertsOn: 'ការជូនដំណឹងបានបើក',
  alertsHint: 'ទទួលបានការជូនដំណឹងនៅពេលមានសារ ឬការជូនដំណឹងថ្មី',
  viewPhoto: 'មើលរូបភាព',
  statusBackground: 'ផ្ទៃខាងក្រោយអត្ថបទ',
  bgNone: 'គ្មានផ្ទៃ',
  // @mentions
  mentionHint: 'វាយ @ ដើម្បីហៅឈ្មោះសមាជិក (ឧ. @sokdara)',
  mentionTip: 'វាយ @ ដើម្បីហៅឈ្មោះសមាជិក',
  // Audio (music / voice)
  music: 'តន្ត្រី',
  audioFile: 'ឯកសារសំឡេង (MP3)',
  audioHint: 'MP3 · អតិបរមា 10 MB · បង្ហាប់ស្វ័យប្រវត្តិដោយរក្សាគុណភាព',
  audioTitle: 'ឈ្មោះបទចម្រៀង (ស្រេចចិត្ត)',
  compressing: 'កំពុងបង្ហាប់…',
  audioUploaded: 'ផ្ទុកសំឡេងរួចរាល់',
  audioTooBig: 'ឯកសារសំឡេងធំពេក — អតិបរមា 10 MB',
  audioTypeBad: 'ទម្រង់សំឡេងមិនត្រឹមត្រូវ (ប្រើ MP3, M4A, WAV, OGG, WEBM)',
  coverImage: 'រូបភាពគម្រប (វិល 360° ពេលលេង)',
  // Voice recording
  recordVoice: 'ថតសំឡេង',
  stopRecording: 'ឈប់ថត',
  sendVoice: 'ផ្ញើសំឡេង',
  voiceSent: 'ផ្ញើសំឡេងរួចរាល់',
  voiceMessage: 'សារសំឡេង',
  voiceComment: 'មតិយោបល់សំឡេង',
  micDenied: 'មិនអាចប្រើមីក្រូហ្វូន (សូមអនុញ្ញាត)',
  micNotSupported: 'កម្មវិធីរុករកនេះមិនស្គាល់ការថតសំឡេងទេ',
  nothingRecorded: 'មិនមានសំឡេងដែលបានថត',
  // Story crop / format
  cropFormat: 'កាត់ និងកំណត់ទម្រង់',
  cropImage: 'កាត់រូបភាព',
  cropHint: 'អូសរូបភាពដើម្បីផ្លាស់ទី · ប្រើស្លាយដើម្បីពង្រីក',
  format: 'ទម្រង់',
  zoom: 'ពង្រីក',
  rotate: 'បង្វិល 90°',
  resetCrop: 'កំណត់ឡើងវិញ',
  applyCrop: 'យល់ព្រម',
  gifNoCrop: 'GIF រក្សាចលនា — មិនអាចកាត់បានទេ',
  shopsFocusNote: 'MiniShop = Ecommerce Multi shop — បើកហាងរបស់អ្នកនៅទីនេះ',
  article: 'អត្ថបទ',
  articleNav: 'អត្ថបទ',
  categoryPost: 'ប្រភេទអត្ថបទ',
  allPosts: 'ទាំងអស់',
  savePost: 'ចំណូលចិត្ត',
  savedPost: 'បានរក្សាទុក',
  savedPosts: 'អត្ថបទដែលបានរក្សាទុក',
  noSavedPosts: 'មិនទាន់មានអត្ថបទដែលបានរក្សាទុក',
  savedToFavorites: 'បានបញ្ចូលទៅចំណូលចិត្ត',
  removedFromFavorites: 'បានដកចេញពីចំណូលចិត្ត',
  allCategories: 'ប្រភេទទាំងអស់',
  shopNav: 'ហាង',
  messageNav: 'សារ',
  notificationNav: 'ការជូនដំណឹង',
  profileNav: 'ប្រវត្តិរូប',
  writePost: 'សរសេរអត្ថបទ',
  writeSomething: 'តើអ្នកចង់ចែករំលែកអ្វី?',
  postTitle: 'ចំណងជើង',
  postDescription: 'ការពិពណ៌នា (សរសេរបានច្រើនបន្ទាត់, លីងពណ៌ខៀវដោយស្វ័យប្រវត្តិ)',
  postDescriptionHint: 'ឧ. សូមស្វាគមន៍មកកាន់ហាងរបស់ខ្ញុំ https://minishopcambodia.store',
  addImages: 'បន្ថែមរូបភាព / GIF',
  videoLink: 'លីងវីដេអូ (YouTube, Vimeo, TikTok, Facebook, Instagram)',
  // ម៉ាក (CodeKhmerLearning ខៀវ + Mini Shop ទឹកក្រូច)
  communityTitle: 'CodeKhmerLearning Community Beta',
  communityBadge: 'សហគមន៍',
  communityByline: 'CKL = CodeKhmerLearning · MiniShop = Ecommerce Multi shop',
  brandCklEq: '= CodeKhmerLearning',
  brandCklDesc: 'CodeKhmerLearning — ផ្នែកខៀវ៖ ការសិក្សាបច្ចេកវិទ្យាព័ត៌មាន វគ្គសិក្សាកូដ ចំណេះដឹង និងមេរៀនបង្ហាញពីរបៀប។',
  brandMiniShopEq: '= Ecommerce Multi shop',
  brandMiniShopDesc: 'MiniShop — ផ្នែកទឹកក្រូច៖ វេទិកាពាណិជ្ជកម្មអេឡិចត្រូនិកពហុហាង (ហាងអនឡាញ ការទូទាត់ ABA Pay/KHQR POS និងការជូនដំណឹងតាម Telegram)។',
  // ស្តូរី
  stories: 'ស្តូរី',
  yourStory: 'ស្តូរីរបស់អ្នក',
  createStory: 'បង្កើតស្តូរី',
  storyPhotoUrl: 'លីងរូបភាព ឬ GIF',
  storyVideoUrl: 'លីងវីដេអូ (Facebook, YouTube, TikTok…)',
  storyTextLabel: 'អត្ថបទ',
  storyBackground: 'ពណ៌ផ្ទៃខាងក្រោយ',
  storyPosted: 'បង្ហោះស្តូរីរួចរាល់',
  uploaded: 'បានផ្ទុកឡើង',
  deleteStoryConfirm: 'លុបស្តូរីនេះ?',
  noStories: 'មិនមានស្តូរីទេ',
  viewers: 'អ្នកមើល',
  storiesHint: 'រូបភាព · GIF · លីងវីដេអូ · អត្ថបទ (រយៈពេល ២៤ ម៉ោង)',
  // ចែករំលែក
  sharePost: 'ចែករំលែកអត្ថបទនេះ',
  copyThisPost: 'ចម្លងអត្ថបទនេះ',
  shareTo: 'ចែករំលែកទៅ',
  shareNative: 'ចែករំលែកតាមឧបករណ៍',
  shareWhatsapp: 'WhatsApp',
  // អត្ថបទវែង (ផ្នែកបន្ថែម)
  addMore: '+ បន្ថែមទៀត',
  addSection: '+ បន្ថែមផ្នែក',
  section: 'ផ្នែក',
  sectionsHint: 'ផ្នែកនីមួយៗមាន រូបភាព លីងវីដេអូ និងការពិពណ៌នា',
  showLess: 'បង្ហាញតិចជាង',
  // ជជែក
  editMessage: 'កែសម្រួលសារ',
  edited: 'បានកែសម្រួល',
  deleteForMe: 'លុបសម្រាប់ខ្ញុំ',
  deleteForEveryone: 'លុបសម្រាប់អ្នកទាំងអស់',
  copyText: 'ចម្លងអត្ថបទ',
  deleteChat: 'លុបការសន្ទនា',
  deleteChatConfirm: 'លុបសារទាំងអស់ក្នុងការសន្ទនានេះ សម្រាប់អ្នក?',
  searchChat: 'ស្វែងរកការសន្ទនា...',
  messageOptions: 'ជម្រើសសារ',

  publish: 'ផ្សព្វផ្សាយ',
  update: 'ធ្វើបច្ចុប្បន្នភាព',
  edit: 'កែប្រែ',
  delete: 'លុប',
  deletePostConfirm: 'តើអ្នកប្រាកដជាចង់លុបអត្ថបទនេះ?',
  deleteCommentConfirm: 'លុបមតិយោបល់នេះ?',
  like: 'ចូលចិត្ត',
  likes: 'ចូលចិត្ត',
  comment: 'មតិយោបល់',
  comments: 'មតិយោបល់',
  share: 'ចែករំលែក',
  shares: 'ចែករំលែក',
  views: 'មើល',
  copyLink: 'ចម្លងលីង',
  linkCopied: 'បានចម្លងលីងរួចហើយ',
  shareFacebook: 'Facebook',
  shareTelegram: 'Telegram',
  follow: 'តាមដាន',
  following: 'កំពុងតាមដាន',
  followBack: 'តាមដានត្រឡប់',
  followers: 'អ្នកតាមដាន',
  posts: 'អត្ថបទ',
  message: 'ផ្ញើសារ',
  sendMessage: 'ផ្ញើ',
  typeMessage: 'សរសេរសារមួយ...',
  noConversations: 'មិនទាន់មានការសន្ទនាទេ',
  noNotifications: 'មិនទាន់មានការជូនដំណឹងទេ',
  markAllRead: 'សម្គាល់ថាបានអានទាំងអស់',
  newNotification: 'ការជូនដំណឹងថ្មី',
  latest: 'ថ្មីបំផុត',
  popular: 'ពេញនិយម',
  followingFeed: 'កំពុងតាមដាន',
  searchCommunity: 'ស្វែងរកអត្ថបទ ឬសមាជិក...',
  noPosts: 'មិនទាន់មានអត្ថបទទេ — សរសេរអត្ថបទដំបូងរបស់អ្នក!',
  loadingPosts: 'កំពុងផ្ទុកអត្ថបទ...',
  loadMore: 'ផ្ទុកបន្ថែម',
  members: 'សមាជិក',
  suggestedMembers: 'សមាជិកដែលអ្នកអាចតាមដាន',
  shopsDirectory: 'បញ្ជីហាងទាំងអស់',
  shopsDirectoryDesc: 'រកមើលហាងទាំងអស់នៅលើ Mini Shop ហើយចុចមើលដើម្បីទៅហាងនោះ',
  viewShop: 'មើលហាង',
  searchShop: 'ស្វែងរកហាង...',
  productsCount: 'ផលិតផល',
  createShopTitle: 'បង្កើតហាងផ្ទាល់ខ្លួន',
  createShopDesc: 'ជ្រើសរើសគម្រោងមួយក្នុងចំណោម ៣ ហើយចាប់ផ្តើមលក់នៅថ្ងៃនេះ',
  choosePlan: 'ជ្រើសរើសគម្រោង',
  joinCommunity: 'ចូលរួមសហគមន៍',
  communityLogin: 'ចូលប្រើសហគមន៍',
  communitySignup: 'បង្កើតគណនីសហគមន៍',
  loginRequiredTitle: 'ត្រូវការចូលប្រើ',
  loginRequiredDesc: 'សូមចូលប្រើគណនីសហគមន៍ដើម្បីបន្ត',
  signOut: 'ចាកចេញ',
  noAccount: 'មិនទាន់មានគណនី?',
  haveAccount: 'មានគណនីរួចហើយ?',
  profile: 'ប្រវត្តិរូប',
  bio: 'អំពីខ្ញុំ',
  website: 'គេហទំព័រ',
  avatar: 'រូបភាពក្បាល',
  cover: 'រូបគម្រប',
  socialLinks: 'បណ្តាញសង្គម',
  saved: 'បានរក្សាទុក',
  myPosts: 'អត្ថបទរបស់ខ្ញុំ',
  uploadImage: 'ផ្ទុករូបភាពឡើង',
  uploading: 'កំពុងផ្ទុកឡើង...',
  remove: 'ដកចេញ',
  readMore: 'អានបន្ថែម',
  pinedPost: 'បានខ្ទាស់',
  communityWelcomeTitle: 'សូមស្វាគមន៍មកកាន់សហគមន៍ Mini Shop',
  communityWelcomeDesc: 'ចែករំលែកអត្ថបទ រូបភាព GIF និងវីដេអូ តាមដានអ្នកដទៃ ជជែក និងរកឃើញហាងថ្មីៗ។',
  goToCommunity: 'ទៅសហគមន៍',
  servicePage: 'អំពីសេវាកម្ម',
  commentPlaceholder: 'សរសេរមតិយោបល់...',
  reply: 'ឆ្លើយតប',
  writeAComment: 'សរសេរមតិយោបល់មួយ',
  seeAll: 'មើលទាំងអស់',
  backToFeed: 'ត្រឡប់ទៅសហគមន៍',
  membersCount: 'សមាជិក',
  categoryLabel: 'ប្រភេទ',
  closeViewer: 'បិទ',
  watchOn: 'មើលនៅ',
  postShared: 'បានចែករំលែករួចហើយ',
  posted: 'បានផ្សព្វផ្សាយរួចហើយ',
  updatedOk: 'បានធ្វើបច្ចុប្បន្នភាពរួចហើយ',
  deletedOk: 'បានលុបរួចហើយ',
  // ចូល/ចុះឈ្មោះដោយ Google តែប៉ុណ្ណោះ (គ្មានទម្រង់ពាក្យសម្ងាត់)
  loginWithGoogle: 'ចូលដោយ Google',
  loginDone: 'អ្នកបានចូលរួចហើយ',
  googleOnlyLogin: 'ចូល ឬបង្កើតគណនី ដោយ Google',
  googleNotReady: 'ការចូលដោយ Google មិនទាន់បានកំណត់ — សូមទាក់ទងអ្នកគ្រប់គ្រង។',
  // តារាងចំណាត់ថ្នាក់ + សញ្ញាសមាជិកដែលអ្នកគ្រប់គ្រងផ្តល់ជូន
  leaderboard: 'តារាងចំណាត់ថ្នាក់',
  leaderboardDesc: 'សមាជិកដែលមានអត្ថបទ ចំណូលចិត្ត សកម្មភាព និងអ្នកតាមដានច្រើនបំផុត។',
  leaderboardEmpty: 'មិនទាន់មានចំណាត់ថ្នាក់ — សរសេរអត្ថបទដំបូង!',
  lbPosts: 'អត្ថបទច្រើនបំផុត',
  lbLikes: 'ចំណូលចិត្តច្រើនបំផុត',
  lbActive: 'សកម្មបំផុត',
  lbFollowers: 'អ្នកតាមដានច្រើនបំផុត',
  allTime: 'គ្រប់ពេល',
  thisMonth: 'ខែនេះ',
  thisWeek: 'សប្តាហ៍នេះ',
  points: 'ពិន្ទុ',
  verifiedBadge: 'សមាជិកបានផ្ទៀងផ្ទាត់',
  vipTier: 'VIP',
  vipGold: 'VIP មាស',
  vipPlatinum: 'VIP ផ្លាទីន',
  // ហាងក្នុងសហគមន៍ — ផលិតផលទាំងអស់ពីគ្រប់ហាង
  allProducts: 'ផលិតផលទាំងអស់',
  shopProductsDesc: 'ផលិតផលទាំងអស់ពីគ្រប់ហាងនៅកន្លែងតែមួយ — ចុចមើលលម្អិត បន្ទាប់មកបន្ថែមទៅកន្ត្រករបស់ហាងនោះ។',
  filterByShop: 'ហាង',
  filterByCategory: 'ប្រភេទផលិតផល',
  allShopsLabel: 'ហាងទាំងអស់',
  newestFirst: 'ថ្មីបំផុតមុន',
  featuredFirst: 'ពិសេសមុន',
  priceLow: 'តម្លៃ៖ ទាបទៅខ្ពស់',
  priceHigh: 'តម្លៃ៖ ខ្ពស់ទៅទាប',
  visitShop: 'ចូលមើលហាង',
  moreFromShop: 'ផលិតផលផ្សេងទៀតពីហាងនេះ',
  addedToCart: 'បានបន្ថែមទៅកន្ត្រក',
  productShared: 'លីងផលិតផលរួចរាល់សម្រាប់ចែករំលែក',
  shopProducts: 'ផលិតផល',
  // កន្ត្រក + ការទិញពីហាងក្នុងសហគមន៍
  sortBy: 'តម្រៀបតាម',
  buyAccountTitle: 'ប្រើគណនីរបស់អ្នកដើម្បីទិញពីហាងនេះ',
  buyAccountNote: 'ចុចម្តងដោយ Google គឺបង្កើតគណនីរបស់អ្នកនៅហាងនេះ (អ៊ីមែលបានផ្ទៀងផ្ទាត់រួច) ដូច្នេះការបញ្ជាទិញត្រូវបានរក្សាទុក ហើយម្ចាស់ហាងឃើញអ្នកជាអតិថិជនរបស់គាត់។ កន្ត្រករបស់អ្នកមិនបាត់ទេ។',
  buyAccountAction: 'ចូលដោយ Google ដើម្បីទិញ',

  // ── Channels · Groups · post options · blocks · verification ──
  channelsNav: 'ឆានែល',
  switchAccount: 'ប្តូរគណនី',
  personalAccount: 'គណនីផ្ទាល់ខ្លួន',
  postingAs: 'កំពុងបង្ហោះជា {name}',
  actingAsChannel: 'កំពុងប្រើគណនីឆានែល',
  switchBack: 'ត្រឡប់ទៅគណនីផ្ទាល់ខ្លួន',
  channelAccountHint: 'អត្ថបទ និងមតិនឹងបង្ហាញជាឈ្មោះឆានែល មិនមែនឈ្មោះអ្នកទេ',
  channelPostBadge: 'ឆានែល',
  commentAsChannel: 'កំពុងឆ្លើយតបជា {name}',
  publishAsChannel: 'បង្ហោះជាឆានែល',
  createChannelShort: 'បង្កើតឆានែលថ្មី',
  channelsTitle: 'ឆានែល (ជាវបាន)',
  channelsDiscover: 'រកឆានែល',
  channelMyChannels: 'ឆានែលរបស់ខ្ញុំ',
  channelMySubscriptions: 'ឆានែលដែលបានជាវ',
  channelCreate: 'បង្កើតឆានែល',
  channelName: 'ឈ្មោះឆានែល',
  channelNickname: 'ឈ្មោះក្រៅ (@nickname)',
  channelAbout: 'អំពីឆានែល',
  channelCategory: 'ប្រភេទឆានែល',
  channelPublic: 'ឆានែលសាធារណៈ',
  channelPublicHint: 'គ្រប់គ្នាអាចរកឃើញ និងជាវបាន',
  channelPrivate: 'ឆានែលឯកជន',
  channelPrivateHint: 'មានតែអ្នកមានតំណទេ',
  channelOpen: 'អនុញ្ញាតឱ្យជាវបានភ្លាមៗ',
  channelApproval: 'ត្រូវរង់ចាំការអនុម័តពីម្ចាស់',
  channelLimit: 'អ្នកអាចបង្កើតឆានែលបានត្រឹម 3 ប៉ុណ្ណោះ',
  channelRemaining: 'អ្នកអាចបង្កើតបានចំនួន {n} ឆានែលទៀត',
  channelEmpty: 'មិនទាន់មានឆានែលទេ',
  channelPosts: 'អត្ថបទក្នុងឆានែល',
  channelEdit: 'កែឆានែល',
  channelProfile: 'រូបភាពប្រវត្តិរូបឆានែល',
  channelUploadProfile: 'ដាក់រូបភាពប្រវត្តិរូប',
  channelCover: 'រូបភាពគម្របឆានែល',
  channelUploadCover: 'ដាក់រូបភាពគម្រប',
  channelDeleteConfirm: 'លុបឆានែលនេះ? អត្ថបទនឹងនៅដដែល។',
  subscribe: 'ជាវ',
  subscribed: 'បានជាវ',
  subscriberPending: 'រង់ចាំការអនុម័ត',
  subscribers: 'អ្នកជាវ',
  subscribeOwnChannel: 'អ្នកជាម្ចាស់ឆានែលនេះ',
  approve: 'អនុម័ត',
  postToChannel: 'បង្ហោះទៅឆានែល',

  groupsNav: 'ក្រុម',
  groupsTitle: 'ក្រុមជជែក',
  groupMyGroups: 'ក្រុមរបស់ខ្ញុំ',
  groupDiscover: 'រកក្រុម',
  groupCreate: 'បង្កើតក្រុម',
  groupName: 'ឈ្មោះក្រុម',
  groupAbout: 'អំពីក្រុម',
  groupPublic: 'ក្រុមសាធារណៈ',
  groupPublicHint: 'គ្រប់គ្នាអាចរកឃើញ និងចូលបាន',
  groupPrivate: 'ក្រុមឯកជន',
  groupPrivateHint: 'មានតែអ្នកមានតំណអញ្ជើញចូលបាន',
  groupAllowMemberInvite: 'សមាជិកអាចអញ្ជើញអ្នកផ្សេងបាន',
  groupJoin: 'ចូលក្រុម',
  groupJoined: 'បានចូលរួម',
  groupJoinOpen: 'ចូលរួមឥឡូវនេះ',
  groupLeave: 'ចាកចេញពីក្រុម',
  groupMembers: 'សមាជិកក្រុម',
  groupSettings: 'ការកំណត់ក្រុម',
  groupChat: 'ជជែកក្រុម',
  groupMessagePlaceholder: 'សរសេរសារទៅក្រុម...',
  groupInvite: 'អញ្ជើញសមាជិក',
  groupInviteLink: 'តំណអញ្ជើញ',
  groupInviteLinkHint: 'ចម្លងតំណនេះបញ្ជូនទៅមិត្តភក្តិដើម្បីចូលក្រុម',
  groupCopyLink: 'ចម្លងតំណ',
  groupResetLink: 'បង្កើតតំណថ្មី',
  groupAddByUsername: 'បន្ថែមតាម @username',
  groupAdd: 'បន្ថែម',
  groupRoleOwner: 'ម្ចាស់ក្រុម',
  groupRoleAdmin: 'អ្នកគ្រប់គ្រង',
  groupRoleMember: 'សមាជិក',
  groupMakeAdmin: 'តែងតាំងជាអ្នកគ្រប់គ្រង',
  groupMakeMember: 'ដកសិទ្ធិអ្នកគ្រប់គ្រង',
  groupTransferOwner: 'ផ្ទេរភាពជាម្ចាស់ក្រុម',
  groupNickname: 'ឈ្មោះក្នុងក្រុម',
  groupNicknameSave: 'រក្សាទុកឈ្មោះ',
  groupLogo: 'រូបសញ្ញាក្រុម',
  groupUploadLogo: 'ដាក់រូបសញ្ញា',
  groupCover: 'រូបភាពគម្របក្រុម',
  groupUploadCover: 'ដាក់រូបភាពគម្រប',
  groupCoverHint: 'រូបភាពគម្របបង្ហាញនៅផ្នែកខាងលើនៃទំព័រក្រុម',
  groupDeleteConfirm: 'លុបក្រុមនេះ និងសារទាំងអស់?',
  groupCreateLimit: 'អ្នកអាចបង្កើតបានត្រឹម 20 ក្រុម',
  groupJoinByLink: 'ចូលរួមតាមតំណអញ្ជើញ',
  groupInviteCode: 'កូដអញ្ជើញ',
  groupInviteInvalid: 'តំណអញ្ជើញនេះលែងមានសុពលភាពទេ',
  groupEmpty: 'មិនទាន់មានក្រុមទេ',
  groupRemoveMemberConfirm: 'ដកសមាជិកនេះចេញពីក្រុម?',
  groupAdminChanged: 'បានផ្លាស់ប្តូរសិទ្ធិអ្នកគ្រប់គ្រង',
  groupsMessagesLink: 'សារក្រុម',

  postOptions: 'ជម្រើសនៃការបង្ហោះសារ',
  visibilityLabel: 'ជម្រើសនៃការបង្ហាញ',
  postPublic: 'បង្ហោះជាសារធារណៈ',
  postPublicHint: 'គ្រប់គ្នាអាចឃើញការបង្ហោះនេះ',
  postFriends: 'បង្ហោះសម្រាប់មិត្តភក្តិ',
  postFriendsHint: 'មិត្តភក្តិទាំងអស់អាចឃើញការបង្ហោះនេះ',
  postOnlyMe: 'ខ្ញុំម្នាក់ប៉ុណ្ណោះ',
  postOnlyMeHint: 'បង្ហោះសម្រាប់ខ្លួនឯង',
  whoCanSee: 'អ្នកដែលអាចឃើញការបង្ហោះនេះ',
  turnOffComments: 'បិទការទទួលមតិ',
  turnOffShare: 'បិទការចែករំលែក',
  shareOptions: 'ជម្រើសនៃការចែករំលែក',
  shareToSocial: 'ចែករំលែកទៅបណ្តាញសង្គមផ្សេងៗទៀត',
  shareToSocialHint: 'ជ្រើសរើសជម្រើសនេះដើម្បីចែករំលែកទៅបណ្តាញសង្គមផ្សេងទៀត',
  commentsOff: 'ម្ចាស់អត្ថបទបានបិទការទទួលមតិ',
  shareOff: 'ម្ចាស់អត្ថបទបានបិទការចែករំលែក',
  badgePublic: 'សាធារណៈ',
  badgeFriends: 'មិត្តភក្តិ',
  badgeOnlyMe: 'ខ្ញុំម្នាក់ប៉ុណ្ណោះ',
  mediaPicture: 'រូបភាព',
  mediaVideo: 'វីដេអូ',
  mediaMusic: 'តន្ត្រី',
  mediaVoice: 'សំឡេង',
  replyTo: 'ឆ្លើយតបទៅ',

  blockUser: 'ប្លុកគណនីនេះ',
  unblockUser: 'ដោះប្លុក',
  blockedNav: 'គណនីដែលបានប្លុក',
  blockedTitle: 'គណនីដែលត្រូវបានប្លុក',
  blockedHint: 'ពេលប្លុក អ្នកនឹងមិនឃើញអត្ថបទ មតិ និងសាររបស់គេ ហើយគេក៏មិនឃើញរបស់អ្នកដែរ។',
  blockedEmpty: 'មិនទាន់មានគណនីដែលបានប្លុកទេ',
  blockConfirm: 'ប្លុក @{u}?',
  unblockConfirm: 'ដោះប្លុក @{u}?',
  blockedOk: 'បានប្លុកគណនីនេះ',
  unblockedOk: 'បានដោះប្លុកគណនីនេះ',

  verifyNav: 'ផ្ទៀងផ្ទាត់',
  verifyTitle: 'ផ្ទៀងផ្ទាត់គណនី',
  verifyIntro: 'បំពេញលក្ខខណ្ឌខាងក្រោម ដើម្បីស្នើសុំសញ្ញាផ្ទៀងផ្ទាត់ ✓',
  verifyProgress: 'បានបំពេញ {done}/{total}',
  verifyApply: 'ស្នើសុំផ្ទៀងផ្ទាត់',
  verifySend: 'ផ្ញើសំណើ',
  verifyPending: 'សំណើរបស់អ្នកកំពុងរង់ចាំការត្រួតពិនិត្យ',
  verifyApproved: 'គណនីរបស់អ្នកបានផ្ទៀងផ្ទាត់រួចហើយ ✓',
  verifyRejected: 'សំណើមិនត្រូវបានអនុម័ត',
  verifyNote: 'សរសេរបន្ថែម (ជាជម្រើស)',
  verifyNotMet: 'មិនទាន់គ្រប់លក្ខខណ្ឌ',
  verifyDone: 'បានបំពេញ',
  verifyCondition: 'លក្ខខណ្ឌ',
  verifyValue: '{value}/{need}',
  verifyComplete: 'បំពេញព័ត៌មាន',
  verifiedByAdmin: 'ត្រូវបានផ្ទៀងផ្ទាត់ដោយអ្នកគ្រប់គ្រង',
  verifyNeedLogin: 'សូមចូលគណនីជាមុន',

  themeLight: 'ភ្លឺ',
  themeDark: 'ងងឹត',
  themeBlack: 'ខ្មៅ (AMOLED)',
  themeTitle: 'ផ្ទាំងពណ៌',

};

const en = {
  home: 'Home',
  products: 'Products',
  about: 'About',
  searchPlaceholder: 'Search products...',
  cart: 'Cart',
  addToCart: 'Add to Cart',
  yourCart: 'Your Cart',
  cartEmpty: 'Your cart is empty',
  subtotal: 'Subtotal',
  proceedCheckout: 'Proceed to Checkout',
  continueShopping: 'Continue shopping',

  shopNow: 'Shop Now',
  featuredProducts: 'Featured Products',
  viewAll: 'View all',
  categories: 'Categories',
  all: 'All',
  chatbot: 'Chat with the shop',
  chatbotPlaceholder: 'Ask about products, prices, delivery...',
  chatbotSend: 'Send',
  chatbotThinking: 'Typing...',
  chatbotError: 'Something went wrong. Please try again.',
  chatbotSuggest: 'Suggested questions',
  articles: 'Articles',
  videos: 'Videos',
  noArticles: 'No articles yet',
  noVideos: 'No videos yet',
  promotion: 'Promotion',
  promotions: 'Promotions',
  promotionOffer: 'Special offer',
  close: 'Close',
  viewImage: 'View larger image',
  prev: 'Previous',
  next: 'Next',
  loading: 'Loading...',
  loadingShop: 'Loading shop...',
  noProducts: 'No products found.',
  noFeatured: 'No featured products yet.',
  productDetails: 'Product Details',
  description: 'Description',
  relatedProducts: 'Related Products',
  back: 'Back',
  inStock: 'In stock',
  outOfStock: 'Out of stock',
  qty: 'Quantity',
  sale: 'SALE',

  checkout: 'Checkout',
  customerInfo: 'Customer Information',
  name: 'Name',
  emailOpt: 'Email (optional)',
  phone: 'Phone',
  telegramOpt: 'Telegram (optional)',
  address: 'Address',
  city: 'City',
  country: 'Country',
  noteOpt: 'Order note (optional)',
  placingOrder: 'Placing order...',
  pay: 'Pay',
  orderSummary: 'Order Summary',
  shipping: 'Shipping',
  free: 'Free',
  total: 'Total',
  securedBy: 'Secured by ABA Pay (KHQR)',
  fillRequired: 'Please fill all required fields',

  orderPlacedTitle: 'Order placed — pay with ABA Pay',
  orderId: 'Order ID',
  amountToPay: 'Amount to Pay',
  merchant: 'Merchant',
  dateTime: 'Date / Time',
  scanWithABA: 'Scan with ABA Mobile App',
  securePayment: 'Secure Payment',
  paywayPoweredBy: 'Powered by ABA Payway · Secure Payment',
  scanQr: 'Scan the KHQR code with your ABA Mobile app, or open the secure checkout page.',
  payWithABA: 'Pay with ABA Pay',
  alreadyPaid: 'I have already paid — verify',
  waitingPayment: 'Waiting for payment confirmation...',
  autoCheck: 'Payment is checked automatically every 3 seconds.',
  transId: 'Transaction',
  paymentConfirmed: 'Payment confirmed! Redirecting...',
  paymentUnavailable: 'Online payment unavailable',
  paymentUnavailableDesc: 'This shop has not configured its ABA Pay yet, so online payment is currently disabled. Please contact the shop to complete your order.',
  backToProducts: 'Back to products',
  paymentPending: 'Payment is still pending. Please complete the payment in ABA Mobile.',

  paymentSuccess: 'Payment Successful!',
  paymentSuccessMsg: 'Thank you for your purchase. A receipt has been generated for your order.',
  orderPlacedMsg: 'Your order has been placed. You can check the payment status below.',
  downloadReceipt: 'Download PDF Receipt',
  downloadInvoice: 'Download PDF Invoice',
  orderNotFound: 'Order not found',
  orderNotFoundDesc: 'We could not find this order. Please check the order number.',
  orderNumber: 'Order Number',
  date: 'Date',
  paymentStatus: 'Payment Status',
  orderStatus: 'Order Status',
  itemsLabel: 'Items',
  customerLabel: 'Customer',

  shopUnavailable: 'Shop unavailable',
  shopNotFoundMsg: 'Shop not found or suspended',
  backHome: 'Back to home',
  aboutUs: 'About us',
  followUs: 'Follow us',
  contact: 'Contact',
  quickLinks: 'Quick links',
  poweredBy: 'Powered by Mini Shop Platform',
  weAccept: 'We accept',
  fastDelivery: 'Fast Delivery',
  fastDeliveryDesc: 'Quick and reliable delivery across the country.',
  abaAccepted: 'ABA Pay Accepted',
  abaAcceptedDesc: 'Pay easily with ABA Mobile by scanning the KHQR code.',
  support: 'Customer Support',
  supportDesc: 'Reach out anytime via Telegram for assistance.',
  welcome: 'Welcome!',
  notFound404: 'Page not found. Try visiting a shop URL like /demo.',
  goToDemo: 'Go to demo shop',
  somethingWrong: 'Something went wrong',
  reload: 'Reload page',

  // my orders (customer history)
  myOrders: 'My Orders',
  myOrdersLoginDesc: 'Enter your phone number or Telegram username to view your order history for this shop.',
  loginWithTelegram: 'Login with Telegram',
  viewMyOrders: 'View My Orders',
  noOrdersFound: 'No orders found for this phone / Telegram yet.',
  viewDetail: 'View Detail',
  hideDetail: 'Close Detail',
  orderDetail: 'Order Details',
  shippingAddress: 'Shipping Address',
  paymentMethod: 'Payment Method',
  transactionId: 'Transaction ID',
  email: 'Email',
  discount: 'Discount',
  ordersFound: 'orders',
  orderHistory: 'Order History',
  logOut: 'Log out',
  dashboard: 'Dashboard',
  viewMyShop: 'View my shop',
  youOwnThisShop: 'You own this shop',
  joinTelegram: 'Join Telegram Channel',
  contactThisOwner: 'Contact this shop owner',
  searchMyOrders: 'Search my orders',

  // telegram login
  tgLoginRequired: 'Please login with Telegram to buy',
  tgLoginRequiredDesc: 'You must login with your Telegram account before you can place an order.',
  tgLoginSuccess: 'Logged in with Telegram!',
  tgLoggedIn: 'Logged in with Telegram',
  tgLoggingIn: 'Logging in...',
  tgFallbackTitle: 'Or login with a code',
  tgFallbackHow: 'No button? Open',
  tgFallbackStart: 'in Telegram, press Start, then enter your Telegram user ID below.',
  tgYourId: 'Your Telegram user ID',
  tgSendCode: 'Send code',
  tgEnterCode: 'Enter the 6-digit code sent to your Telegram',
  tgVerify: 'Verify',
  tgBack: 'Back',
  tgInvalidId: 'Please enter a valid Telegram user ID (numbers only)',
  tgInvalidCode: 'Code must be 6 digits',
  tgCodeSent: 'Verification code sent to your Telegram!',

  // customer account
  signIn: 'Sign In',
  signUp: 'Sign Up',
  createAccount: 'Create Account',
  emailOrPhone: 'Email or Phone',
  loginIdentifier: 'Username or Gmail',
  username: 'Username',
  myProfile: 'My Account',
  viewProfile: 'View Account',
  fullName: 'Full Name',
  memberSince: 'Member since',
  editProfile: 'Edit Profile',
  save: 'Save',
  cancel: 'Cancel',
  profileUpdated: 'Your profile has been updated!',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  passwordUpdated: 'Password changed successfully!',
  updatePassword: 'Update Password',
  qrCode: 'Scan QR',
  downloadQr: 'Download QR',
  scanToVisit: 'Scan to visit the shop',
  telegram: 'Telegram',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  passwordMismatch: 'Passwords do not match! Please check again',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  firstName: 'First Name',
  lastName: 'Last Name',
  gender: 'Gender',
  male: 'Male',
  female: 'Female',
  other: 'Other',
  gmail: 'Email (Gmail)',
  telegramUsername: 'Telegram Username',
  telegramPhone: 'Telegram Phone',
  welcomeBack: 'Welcome back',
  signInRequired: 'Please sign in to buy',
  signInRequiredDesc: 'Create an account or sign in to place orders and view your order history.',

  heroTitle: 'Welcome to Mini Shop',
  heroSubtitle: 'A multi-shop e-commerce platform with ABA Pay (KHQR) payments, PDF receipts and Telegram notifications.',
  featuresTitle: 'Platform Features',
  featuresLabel: 'Features',
  featureMultiShop: 'Multi-Shop Platform',
  featureMultiShopDesc: 'Each shop gets its own unique username and dedicated storefront (/:username).',
  featureCustom: 'Full Shop Customization',
  featureCustomDesc: 'Custom logo, banner, theme colors and font for every shop.',
  featureAbapay: 'ABA Pay Integration',
  featureAbapayDesc: 'Secure KHQR payment processing for each shop.',
  featureReceipts: 'PDF Receipts',
  featureReceiptsDesc: 'Printable PDF receipts with your shop logo and order details.',
  featureBackup: 'Backup & Restore',
  featureBackupDesc: 'Backup and restore all shop data (JSON/ZIP).',
  featureTelegram: 'Telegram Notifications',
  featureTelegramDesc: 'Get instant payment alerts sent to your Telegram group.',
  howItWorks: 'How to start your shop',
  howItWorksDesc: 'Accounts are created by the platform admin only (no self-registration). Contact us on Telegram:',
  browseDemo: 'Browse the demo shop',
  viewAdmin: 'Admin Panel',
  viewDashboard: 'Shop Dashboard',
  poweredText: 'Powered by Mini Shop Platform',
  pricingTitle: 'Pricing Plans',
  pricingSubtitle: 'Choose the plan that fits your shop — add more money anytime to upgrade.',
  planStarter: 'Starter',
  planStarterPrice: '$9.99',
  planStarterPeriod: '/1 month',
  createShopHero: 'Own your online store in minutes — from $9.99/month.',
  planStarterFeat: ['20 products', '10 categories', 'ABA PayWay (KHQR)'],
  planGrowth: 'Growth',
  planGrowthPrice: '$55.99',
  planGrowthPeriod: '/6 months',
  planGrowthFeat: ['50 products', '20 categories', 'ABA PayWay (KHQR)'],
  planPremium: 'Premium',
  planPremiumPrice: '$99.99',
  planPremiumPeriod: '/1 year',
  planPremiumFeat: ['200 products', '30 categories', 'ABA PayWay (KHQR)'],
  everythingIncluded: 'Everything included',
  planIncludes: ['POS Sale', 'Products', 'Categories', 'Stock', 'Orders', 'Customers',
                 'Reports', 'Receipts', 'Shop Settings', 'Payment (ABA Pay)',
                 'Telegram Bot', 'Backup & Import'],
  popularTag: 'Most popular',
  upgradeNote: 'Need more products or categories? Add money to upgrade your plan ($99.99/year).',
  openShop: 'Open your shop',
  openShopDesc: 'Contact @thymuoyhak to open a new shop today',
  tryDemo: 'Try the live demo',
  liveDemoTitle: 'See a live demo shop',
  liveDemoDesc: 'This is a real shop running on Mini Shop — browse products and try the checkout flow.',

  // homepage (brand landing)
  heroBadge: "🇰🇭 Cambodia's Multi-Shop E-Commerce Platform",
  heroTitleMain: 'Own your online shop',
  heroTitleMain2: 'in minutes.',
  heroDesc: 'Mini Shop Cambodia lets you open a professional online store with your own link, ABA Pay (KHQR) payments, PDF invoices, POS system and Telegram alerts — no coding, no fees to start, no commission on your sales.',
  browseDemo2: 'Browse a demo shop',
  startMyShop: 'Create my shop',
  needHelp: 'Need help?',
  statShops: 'Shops on the platform',
  statProducts: 'Products live',
  statCustomers: 'Happy customers',
  statSupport: 'Support & monitoring',
  aboutLabel: 'About Mini Shop Cambodia',
  aboutTitle: 'Everything you need to sell online in Cambodia',
  aboutP1: 'Mini Shop Cambodia is a complete multi-shop platform built for local businesses. Every shop gets its own storefront with a personal link, a full shop dashboard (products, categories, stock, orders, customers, reports), a professional POS system, and real ABA Pay (KHQR) checkout so customers can pay instantly with their phone.',
  aboutP2: 'Payments are confirmed automatically, bilingual PDF invoices are generated for every order (Khmer + English, with your logo and brand color), and you get instant Telegram notifications — every new order, payment and low-stock alert straight to your phone.',
  aboutPoint1: 'Free to start — pay only when you pick a plan',
  aboutPoint2: 'No commission taken on your sales',
  aboutPoint3: 'Khmer & English storefront and admin',
  aboutPoint4: 'Mobile-friendly for every customer',
  talkToUs: 'Talk to us',
  value500: '500+ shops',
  value500Desc: 'A growing marketplace of local businesses across Cambodia.',
  valueAba: 'ABA Pay (KHQR)',
  valueAbaDesc: 'Real Khmer QR payments — scan & pay in seconds.',
  valueInv: 'PDF invoices',
  valueInvDesc: 'Professional bilingual invoices with your brand.',
  valueDel: 'Manage delivery',
  valueDelDesc: 'Customer address & order statuses end-to-end.',
  stepsTitle: 'Get online in 3 simple steps',
  step1Title: 'Create your shop',
  step1Desc: 'Pick a plan, register your shop in 2 minutes and pay securely with ABA Pay (KHQR).',
  step2Title: 'Add products & style',
  step2Desc: 'Upload your products, categories, logo, banner and brand color. No coding needed.',
  step3Title: 'Start selling',
  step3Desc: 'Get your storefront link, receive orders + ABA payments, and grow your business.',
  pricingLabel: 'Pricing',
  testiLabel: 'Shop owners love it',
  testiTitle: 'Trusted by hundreds of shops',
  testi1Name: 'Sokha M.',
  testi1Shop: 'Fashion @sokhastyle',
  testi1Text: 'I opened my shop in one evening and got my first ABA payment the next day. The invoice PDF is so professional!',
  testi2Name: 'Dara K.',
  testi2Shop: 'Gadgets @darashop',
  testi2Text: 'The POS system makes in-store sales so easy. My Telegram gets every order instantly.',
  testi3Name: 'Chan R.',
  testi3Shop: 'Beauty @chanshop',
  testi3Text: 'Khmer + English support and the shop theme colors match my brand perfectly.',
  ctaTitle: 'Ready to grow your business online?',
  ctaDesc: 'Join 500+ shops on Mini Shop Cambodia today — it takes minutes to start.',
  startFree: 'Start my shop free',
  loadingMore: 'Loading more products...',
  showMore: 'Show more',
  footerAbout: 'Mini Shop Cambodia — the multi-shop e-commerce platform that lets anyone open an online store with ABA Pay, POS and professional invoices.',
  aboutMiniShop: 'About Mini Shop',
  startYourShop: 'Start your shop',
  contactFooter: 'Contact',
  contactShops: '500+ shops · Phnom Penh, Cambodia 🇰🇭',
  contactSupport: 'Support: 24/7',
  copyright: '© {year} Mini Shop Cambodia',

  // ---- Mini Shop Community (social platform) ----
  community: 'Welcome to CodeKhmerLearning Community Beta',
  communityTagline: 'Share knowledge, articles, videos and everything you care about',
  communityFreeForAll: 'Everyone can share · free',
  moreFromAuthor: 'More articles from this member',
  joined: 'Joined',
  soundEffects: 'Button sounds',
  soundOn: 'Turn sounds on',
  soundOff: 'Turn sounds off',
  // Facebook-like post types + video / reels
  postTypeStatus: 'Status',
  postTypePhoto: 'Photo',
  postTypeVideo: 'Video',
  postTypeStatusHint: 'Write something and share it with the community ✍️',
  postTypePhotoHint: 'Add photos / GIF and write a caption 📷',
  postTypeVideoHint: 'Upload a video (max 10 MB, compressed automatically) or paste a video link 🎬',
  addVideo: 'Add video',
  videoFile: 'Video',
  videoHint: 'MP4 · max 10 MB · compressed automatically',
  videoUploaded: 'Video uploaded',
  reelBadge: 'Reel',
  reelVerticalHint: 'Vertical video (9:16) — it will also appear in Reels 🎬',
  reelNav: 'Reel',
  reelsTitle: 'Reels',
  reelsHint: 'Swipe up for the next video · tap the name to open that profile',
  noReels: 'No Reels yet',
  noReelsHint: 'Post a vertical (9:16) video — or paste a video link (YouTube Shorts · TikTok · Reel) — to show it here',
  noMoreReels: 'No more Reels',
  mute: 'Mute',
  unmute: 'Unmute',
  openPost: 'Open post',
  tapForSound: 'Tap once to turn the sound on (the browser blocked it)',
  randomFeed: 'Random',
  noMorePosts: 'No more articles',
  orUpload: 'or upload',
  videoStory: 'Video story',
  uploadVideo: 'Upload video',
  uploadVideo10: 'Upload video (max 10 MB)',
  videoCompressHint: 'The video is compressed for you automatically (MP4 · 720p)',
  storyVideoMuted: 'Tap to turn the sound on',
  sharePreviewHint: 'This is the picture + title Facebook and Telegram will show',
  sideMenu: 'Side menu',
  generalMenu: 'General',
  uploadImages: 'Upload pictures',
  imagesReady: 'Pictures ready — press Send',
  pressSend: 'press Send',
  clearAll: 'Clear all',
  enableAlerts: 'Enable browser alerts',
  alertsOn: 'Browser alerts are on',
  alertsHint: 'Get an alert when a new message or notification arrives',
  viewPhoto: 'View photo',
  statusBackground: 'Text background',
  bgNone: 'No background',
  // @mentions
  mentionHint: 'Type @ to mention a member (e.g. @sokdara)',
  mentionTip: 'Type @ to mention a member',
  // Audio (music / voice)
  music: 'Music',
  audioFile: 'Audio file (MP3)',
  audioHint: 'MP3 · max 10 MB · compressed automatically, quality kept',
  audioTitle: 'Track title (optional)',
  compressing: 'Compressing…',
  audioUploaded: 'Audio uploaded',
  audioTooBig: 'The audio file is too big — the maximum is 10 MB',
  audioTypeBad: 'Unsupported audio type (use MP3, M4A, WAV, OGG or WEBM)',
  coverImage: 'Cover image (spins 360° while playing)',
  // Voice recording
  recordVoice: 'Record voice',
  stopRecording: 'Stop',
  sendVoice: 'Send voice',
  voiceSent: 'Voice sent',
  voiceMessage: 'Voice message',
  voiceComment: 'Voice comment',
  micDenied: 'Microphone not allowed — please allow it and try again',
  micNotSupported: 'This browser cannot record audio',
  nothingRecorded: 'Nothing was recorded',
  // Story crop / format
  cropFormat: 'Crop & format',
  cropImage: 'Crop image',
  cropHint: 'Drag the image to move it · use the slider to zoom',
  format: 'Format',
  zoom: 'Zoom',
  rotate: 'Rotate 90°',
  resetCrop: 'Reset',
  applyCrop: 'Apply',
  gifNoCrop: 'GIF keeps its animation — cropping is disabled',
  shopsFocusNote: 'MiniShop = Ecommerce Multi shop — open your own shop here (blue + orange = MiniShop)',
  article: 'Article',
  articleNav: 'Article',
  categoryPost: 'Category Post',
  allPosts: 'All',
  savePost: 'Favorite',
  savedPost: 'Saved',
  savedPosts: 'Saved articles',
  noSavedPosts: 'No saved articles yet',
  savedToFavorites: 'Added to favourites',
  removedFromFavorites: 'Removed from favourites',
  allCategories: 'All categories',
  shopNav: 'Shop',
  messageNav: 'Messages',
  notificationNav: 'Notifications',
  profileNav: 'Profile',
  writePost: 'Write an article',
  writeSomething: 'What do you want to share?',
  postTitle: 'Title',
  postDescription: 'Description (multi-line — links are detected and shown in blue)',
  postDescriptionHint: 'e.g. Welcome to my shop https://minishopcambodia.store',
  addImages: 'Add images / GIF',
  videoLink: 'Video link (YouTube, Vimeo, TikTok, Facebook, Instagram)',
  // Brand (CodeKhmerLearning blue + Mini Shop orange)
  communityTitle: 'CodeKhmerLearning Community',
  communityBadge: 'Community',
  communityByline: 'CKL = CodeKhmerLearning · MiniShop = Ecommerce Multi shop',
  brandCklEq: '= CodeKhmerLearning',
  brandCklDesc: 'CodeKhmerLearning — the blue side: IT learning, coding courses, knowledge and how-to tutorials.',
  brandMiniShopEq: '= Ecommerce Multi shop',
  brandMiniShopDesc: 'MiniShop — the orange side: the multi-shop ecommerce platform (online store, ABA Pay / KHQR, POS and Telegram alerts).',
  // Stories
  stories: 'Stories',
  yourStory: 'Your story',
  createStory: 'Create story',
  storyPhotoUrl: 'Photo or GIF link',
  storyVideoUrl: 'Video link (Facebook, YouTube, TikTok…)',
  storyTextLabel: 'Text',
  storyBackground: 'Background colour',
  storyPosted: 'Story posted',
  uploaded: 'Uploaded',
  deleteStoryConfirm: 'Delete this story?',
  noStories: 'No stories yet',
  viewers: 'Viewers',
  storiesHint: 'Photo · GIF · Video link · Text (24 hours)',
  // Share sheet
  sharePost: 'Share this post',
  copyThisPost: 'Copy this post',
  shareTo: 'Share to',
  shareNative: 'Share via device',
  shareWhatsapp: 'WhatsApp',
  // Long articles (blocks)
  addMore: '+ Add more',
  addSection: '+ Add more section',
  section: 'Section',
  sectionsHint: 'Each section can hold images, a video link and text',
  showLess: 'Show less',
  // Chat
  editMessage: 'Edit message',
  edited: 'edited',
  deleteForMe: 'Delete for me',
  deleteForEveryone: 'Delete for everyone',
  copyText: 'Copy text',
  deleteChat: 'Delete chat',
  deleteChatConfirm: 'Delete every message in this chat for you?',
  searchChat: 'Search conversations…',
  messageOptions: 'Message options',

  publish: 'Publish',
  update: 'Update',
  edit: 'Edit',
  delete: 'Delete',
  deletePostConfirm: 'Delete this article?',
  deleteCommentConfirm: 'Delete this comment?',
  like: 'Like',
  likes: 'Likes',
  comment: 'Comment',
  comments: 'Comments',
  share: 'Share',
  shares: 'Shares',
  views: 'Views',
  copyLink: 'Copy link',
  linkCopied: 'Link copied',
  shareFacebook: 'Facebook',
  shareTelegram: 'Telegram',
  follow: 'Follow',
  following: 'Following',
  followBack: 'Follow back',
  followers: 'Followers',
  posts: 'Posts',
  message: 'Message',
  sendMessage: 'Send',
  typeMessage: 'Write a message...',
  noConversations: 'No conversations yet',
  noNotifications: 'No notifications yet',
  markAllRead: 'Mark all as read',
  newNotification: 'New notification',
  latest: 'Latest',
  popular: 'Popular',
  followingFeed: 'Following',
  searchCommunity: 'Search articles or members...',
  noPosts: 'No articles yet — write your first one!',
  loadingPosts: 'Loading articles...',
  loadMore: 'Load more',
  members: 'Members',
  suggestedMembers: 'Members you may follow',
  shopsDirectory: 'All shops',
  shopsDirectoryDesc: 'Browse every shop on Mini Shop and tap View to open its storefront',
  viewShop: 'View shop',
  searchShop: 'Search shops...',
  productsCount: 'Products',
  createShopTitle: 'Create your own shop',
  createShopDesc: 'Pick one of the 3 plans and start selling today',
  choosePlan: 'Choose a plan',
  joinCommunity: 'Join the community',
  communityLogin: 'Community login',
  communitySignup: 'Create community account',
  loginRequiredTitle: 'Login required',
  loginRequiredDesc: 'Please sign in to your community account to continue',
  signOut: 'Sign out',
  noAccount: "Don't have an account?",
  haveAccount: 'Already have an account?',
  profile: 'Profile',
  bio: 'About me',
  website: 'Website',
  avatar: 'Avatar',
  cover: 'Cover',
  socialLinks: 'Social links',
  saved: 'Saved',
  myPosts: 'My articles',
  uploadImage: 'Upload image',
  uploading: 'Uploading...',
  remove: 'Remove',
  readMore: 'Read more',
  pinedPost: 'Pinned',
  communityWelcomeTitle: 'Welcome to Mini Shop Community',
  communityWelcomeDesc: 'Share articles, GIFs and videos, follow people, chat and discover new shops.',
  goToCommunity: 'Go to community',
  servicePage: 'Our service',
  commentPlaceholder: 'Write a comment...',
  reply: 'Reply',
  writeAComment: 'Write a comment',
  seeAll: 'See all',
  backToFeed: 'Back to community',
  membersCount: 'Members',
  categoryLabel: 'Category',
  closeViewer: 'Close',
  watchOn: 'Watch on',
  postShared: 'Shared',
  posted: 'Published',
  updatedOk: 'Updated',
  deletedOk: 'Deleted',
  // Login / register with Google — the only way in (no password forms)
  loginWithGoogle: 'Continue with Google',
  loginDone: 'You are signed in',
  googleOnlyLogin: 'Sign in — or create your account — with Google',
  googleNotReady: 'Google sign-in is not set up yet — please contact the admin.',
  // Leaderboard + the admin-granted member badges
  leaderboard: 'Leaderboard',
  leaderboardDesc: 'The members with the most articles, likes, activity and followers.',
  leaderboardEmpty: 'No ranking yet — be the first to post!',
  lbPosts: 'Most articles',
  lbLikes: 'Most likes',
  lbActive: 'Most active',
  lbFollowers: 'Most followers',
  allTime: 'All time',
  thisMonth: 'This month',
  thisWeek: 'This week',
  points: 'points',
  verifiedBadge: 'Verified member',
  vipTier: 'VIP',
  vipGold: 'VIP Gold',
  vipPlatinum: 'VIP Platinum',
  // Community shop — all products of all shops
  allProducts: 'All products',
  shopProductsDesc: 'Every product of every shop in one place — open one for the details, then add it to that shop\'s cart.',
  filterByShop: 'Shops',
  filterByCategory: 'Categories',
  allShopsLabel: 'All shops',
  newestFirst: 'Newest first',
  featuredFirst: 'Featured first',
  priceLow: 'Price: low to high',
  priceHigh: 'Price: high to low',
  visitShop: 'Visit shop',
  moreFromShop: 'More from this shop',
  addedToCart: 'Added to the cart',
  productShared: 'The product link is ready to share',
  shopProducts: 'Products',
  // Cart + buying from the community shop
  sortBy: 'Sort by',
  buyAccountTitle: 'Use your account to buy from this shop',
  buyAccountNote: 'One tap with Google creates your account in this shop (your email is already verified), so the order is saved to your account and the owner sees you as their customer. Nothing leaves your cart.',
  buyAccountAction: 'Continue with Google to buy',

  // ── Channels · Groups · post options · blocks · verification ──
  channelsNav: 'Channels',
  switchAccount: 'Switch account',
  personalAccount: 'Personal account',
  postingAs: 'Posting as {name}',
  actingAsChannel: 'You are using a channel account',
  switchBack: 'Back to my account',
  channelAccountHint: 'Articles and comments are published as the channel, not as you',
  channelPostBadge: 'Channel',
  commentAsChannel: 'Commenting as {name}',
  publishAsChannel: 'Publish as the channel',
  createChannelShort: 'Create a new channel',
  channelsTitle: 'Channels ( subscribe )',
  channelsDiscover: 'Discover channels',
  channelMyChannels: 'My channels',
  channelMySubscriptions: 'Channels I subscribed to',
  channelCreate: 'Create channel',
  channelName: 'Channel name',
  channelNickname: 'Nickname (@handle)',
  channelAbout: 'About this channel',
  channelCategory: 'Channel category',
  channelPublic: 'Public channel',
  channelPublicHint: 'Everybody can find it and subscribe',
  channelPrivate: 'Private channel',
  channelPrivateHint: 'Only people with the link',
  channelOpen: 'Anybody may subscribe right away',
  channelApproval: 'New subscribers need the owner’s approval',
  channelLimit: 'You can create up to 3 channels',
  channelRemaining: 'You can still create {n} channel(s)',
  channelEmpty: 'No channels yet',
  channelPosts: 'Articles in this channel',
  channelEdit: 'Edit channel',
  channelProfile: 'Channel profile photo',
  channelUploadProfile: 'Upload photo',
  channelCover: 'Channel cover',
  channelUploadCover: 'Upload cover',
  channelDeleteConfirm: 'Delete this channel? Its articles stay in the community.',
  subscribe: 'Subscribe',
  subscribed: 'Subscribed',
  subscriberPending: 'Waiting for approval',
  subscribers: 'Subscribers',
  subscribeOwnChannel: 'You own this channel',
  approve: 'Approve',
  postToChannel: 'Publish in a channel',

  groupsNav: 'Groups',
  groupsTitle: 'Chat groups',
  groupMyGroups: 'My groups',
  groupDiscover: 'Discover groups',
  groupCreate: 'Create group',
  groupName: 'Group name',
  groupAbout: 'About the group',
  groupPublic: 'Public group',
  groupPublicHint: 'Everybody can find it and join',
  groupPrivate: 'Private group',
  groupPrivateHint: 'Only people with the invite link can join',
  groupAllowMemberInvite: 'Members can invite other people',
  groupJoin: 'Join group',
  groupJoined: 'Joined',
  groupJoinOpen: 'Join now',
  groupLeave: 'Leave the group',
  groupMembers: 'Group members',
  groupSettings: 'Group settings',
  groupChat: 'Group chat',
  groupMessagePlaceholder: 'Write a message to the group...',
  groupInvite: 'Invite members',
  groupInviteLink: 'Invite link',
  groupInviteLinkHint: 'Send this link to your friends so they can join',
  groupCopyLink: 'Copy link',
  groupResetLink: 'New invite link',
  groupAddByUsername: 'Add by @username',
  groupAdd: 'Add',
  groupRoleOwner: 'Owner',
  groupRoleAdmin: 'Admin',
  groupRoleMember: 'Member',
  groupMakeAdmin: 'Make admin',
  groupMakeMember: 'Remove admin',
  groupTransferOwner: 'Transfer ownership',
  groupNickname: 'Group nickname',
  groupNicknameSave: 'Save nickname',
  groupLogo: 'Group logo',
  groupUploadLogo: 'Upload logo',
  groupCover: 'Group cover',
  groupUploadCover: 'Upload cover',
  groupCoverHint: 'The cover is shown at the top of the group page',
  groupDeleteConfirm: 'Delete this group and all its messages?',
  groupCreateLimit: 'You can create up to 20 groups',
  groupJoinByLink: 'Join with an invite link',
  groupInviteCode: 'Invite code',
  groupInviteInvalid: 'This invite link is no longer valid',
  groupEmpty: 'No groups yet',
  groupRemoveMemberConfirm: 'Remove this member from the group?',
  groupAdminChanged: 'Admin rights updated',
  groupsMessagesLink: 'Group messages',

  postOptions: 'Post options',
  visibilityLabel: 'Who can see this post',
  postPublic: 'Post publicly',
  postPublicHint: 'Everybody can see this post',
  postFriends: 'Post for friends',
  postFriendsHint: 'All your friends can see this post',
  postOnlyMe: 'Only me',
  postOnlyMeHint: 'Post for yourself',
  whoCanSee: 'Who can see this post',
  turnOffComments: 'Turn off comments',
  turnOffShare: 'Turn off sharing',
  shareOptions: 'Sharing options',
  shareToSocial: 'Share to other social networks too',
  shareToSocialHint: 'Choose this to share the post to the other social networks',
  commentsOff: 'The author turned comments off',
  shareOff: 'The author turned sharing off',
  badgePublic: 'Public',
  badgeFriends: 'Friends',
  badgeOnlyMe: 'Only me',
  mediaPicture: 'Picture',
  mediaVideo: 'Video',
  mediaMusic: 'Music',
  mediaVoice: 'Voice',
  replyTo: 'Replying to',

  blockUser: 'Block this account',
  unblockUser: 'Unblock',
  blockedNav: 'Blocked accounts',
  blockedTitle: 'Blocked accounts',
  blockedHint: 'While blocked you do not see their articles, comments or messages — and they do not see yours.',
  blockedEmpty: 'No blocked accounts yet',
  blockConfirm: 'Block @{u}?',
  unblockConfirm: 'Unblock @{u}?',
  blockedOk: 'The account is blocked',
  unblockedOk: 'The account is unblocked',

  verifyNav: 'Verification',
  verifyTitle: 'Account verification',
  verifyIntro: 'Meet the conditions below to apply for the ✓ verified mark',
  verifyProgress: '{done}/{total} completed',
  verifyApply: 'Apply for verification',
  verifySend: 'Submit application',
  verifyPending: 'Your application is waiting for review',
  verifyApproved: 'Your account is already verified ✓',
  verifyRejected: 'Your application was not approved',
  verifyNote: 'Add a note (optional)',
  verifyNotMet: 'Conditions not met yet',
  verifyDone: 'Done',
  verifyCondition: 'Condition',
  verifyValue: '{value}/{need}',
  verifyComplete: 'Complete your profile',
  verifiedByAdmin: 'Verified by an administrator',
  verifyNeedLogin: 'Please sign in first',

  themeLight: 'Light',
  themeDark: 'Dark',
  themeBlack: 'Black (AMOLED)',
  themeTitle: 'Theme',

};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('ms_lang') || 'kh');

  useEffect(() => {
    localStorage.setItem('ms_lang', lang);
    document.documentElement.lang = lang === 'kh' ? 'km' : 'en';
  }, [lang]);

  const t = (key) => {
    const dict = lang === 'kh' ? kh : en;
    return dict[key] || en[key] || key;
  };

  const toggle = () => setLang((prev) => (prev === 'kh' ? 'en' : 'kh'));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);

